import type { NuxtUiTheme } from '../types/nuxt-ui-theme';

export default {
    variants: {
        variant: {
            lineHeader: {
                root:
                    'relative overflow-hidden bg-(image:--surface-card-bg) ' +
                    '[backdrop-filter:blur(1.125rem)_saturate(1.4)] border-[0.063rem]! border-solid! ' +
                    'border-(--white-alpha-70)! rounded-(--border-radius-md) shadow-(--surface-card-shadow) ' +
                    'before:content-[""] before:absolute before:top-0 before:left-[5%] before:right-[5%] ' +
                    'before:h-[0.063rem] before:bg-(image:--section-divider-bg) before:pointer-events-none',

                header: 'p-0!',
                body:
                    'grid grid-cols-[minmax(0,1fr)_6.875rem_7rem_7.125rem_7.25rem_3.75rem] items-center ' +
                    'justify-items-start px-5! py-[0.7rem]! gap-2 [&>span]:font-(family-name:--secondary-font) ' +
                    '[&>div]:font-(family-name:--secondary-font) [&>span]:text-[0.72rem] [&>div]:text-[0.72rem] ' +
                    '[&>span]:font-bold [&>div]:font-bold [&>span]:tracking-[0.06em] [&>div]:tracking-[0.06em] ' +
                    '[&>span]:uppercase [&>div]:uppercase [&>span]:text-(--accent-solid) ' +
                    '[&>div]:text-(--accent-solid) [&>span]:whitespace-nowrap [&>div]:whitespace-nowrap ' +
                    '[&>span:not(:first-child)]:text-right [&>div:not(:first-child)]:text-right',

                footer: 'p-0!'
            }
        }
    }
} satisfies NuxtUiTheme['card'];
